<template>
  <div v-if="$store.state.user.role == 1" class="">
    <div class="overflow-hidden">
      <div class="float-left hidden lg:block">
        <Filters />
      </div>

      <div class="ml-0 lg:ml-64">
        <ClientList />
      </div>
    </div>

    <AddClientModal />
    <AddClientViaTemplateModal />
    <NotepadModal />
    <SettledModal />
    <SendClientModal />
  </div>
</template>

<script>
  import ClientList                 from "./ClientList"
  import { EventBus }               from '@/shared/event-bus'
  import AddClientModal             from './AddClientModal'
  import AddClientViaTemplateModal  from './AddClientViaTemplateModal'
  import Filters                    from "./Filters"
  import NotepadModal               from './NotepadModal'
  import SettledModal               from './SettledModal'
  import SendClientModal            from './SendClientModal'

  export default {

    components : {
      AddClientModal,
      AddClientViaTemplateModal,
      ClientList,
      Filters,
      NotepadModal,
      SettledModal,
      SendClientModal
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 0) {
            this.clientType = 'active'
          }

          else {
            this.clientType = to.params.clientType
          }
        }
      }
    },

    data() {
      return {
        clientType   : 'active',
        numActive    : null,
        numSettled   : null,
        numPending: null
      }
    },

    created() {
      if (!this.$store.state[this.$store.state.view + 'Module'].broker.suspended) {
        _.delay( () => {
          this.getNumClientsByType()
        }, 1000)

        window.addEventListener('keyup', (event) => {
          // ESC pressed
          if(event.keyCode == 27) {
            EventBus.$emit('close-client-actions')
          }
        });
      }
    },

    mounted() {
      EventBus.$on('toggle-settled', (client) => {
        this.toggleSettled(client)
      })

      EventBus.$on('get-num-clients-by-type', () => {
        this.getNumClientsByType();
      })

      EventBus.$on('toggle-access', (params) => {
        this.toggleAccess(params)
      })

      EventBus.$on('add-new-client', () => {
        this.addNewClient()
      })

      if(this.$store.state.user.free_version_notice) {
        this.$modal.show('free-version-notice-modal')
      }
    },

    beforeDestroy() {
      EventBus.$off('toggle-settled')
      EventBus.$off('toggle-access')
      EventBus.$off('delete-client')
      EventBus.$off('add-new-client')
      EventBus.$off('get-num-clients-by-type')
    },

    methods : {

      // get the total number of clients that are in active, settled or pending
      getNumClientsByType() {
        this.apiGet({}, 'client/num-clients-by-type', (data) => {
          this.numActive  = null
          this.numSettled = null
          this.numPending = null

          for(let i=0; i < data.length; i++) {

            if(data[i].settled == 0) {
              this.numActive = data[i].num
            }

            else if(data[i].settled == 1) {
              this.numSettled = data[i].num
            }

            else if(data[i].settled = 2) {
              this.numPending = data[i].num
            }
          }
        })
      },

      toggleSettled(client) {
        EventBus.$emit('close-client-actions')
        this.showLoader("Updating...")
        this.apiPost({
          clientId: client.id,
          settled : '0'
        }, 'client/toggle-settled', () => {
          this.hideLoader()
          EventBus.$emit('fetch-clients')
          this.getNumClientsByType()
          EventBus.$emit('notification-event', {
            type   : 'success',
            message: 'Client updated successfully.'
          });
        })
      },

      toggleAccess(params) {
        EventBus.$emit('close-client-actions')
        this.showLoader("Updating...")
        this.apiPost({
          clientId       : params.clientId,
          enableOrDisable: params.enableOrDisable
        }, 'client/toggle-access', () => {
          this.hideLoader()
          EventBus.$emit('fetch-clients')
          EventBus.$emit('notification-event', {
            'type'  : 'success',
            'message': 'Access ' + params.enableOrDisable + "d successfully"
          });
        })
      },
    }
  }
</script>